module.exports = __webpack_public_path__ + "img/1 (21).35f370f0.png";